import type {
    ContactVersion,
    LawFirmContactDetail,
    LawFirmContactListParams,
    LawFirmContactListResponse,
} from '@common/types/contacts';
import axiosInstance from '@/services/axiosInstance';

export interface UpdateContactPayload {
    firstName: string;
    middleName?: string;
    lastName: string;
    email: string;
    phoneNumber?: string;
}

export async function updateContactById(
    contactId: string,
    payload: UpdateContactPayload,
): Promise<ContactVersion> {
    const response = await axiosInstance.put<ContactVersion>(
        `api/v1/contacts/${contactId}`,
        payload,
    );
    return response.data;
}

export async function fetchContactsByLawFirmId(
    lawFirmId: number,
    params: LawFirmContactListParams = {},
): Promise<LawFirmContactListResponse> {
    const response = await axiosInstance.get<LawFirmContactListResponse>(
        `/api/v1/contacts/law-firm/${lawFirmId}`,
        {
            params: {
                page: params.page ?? 0,
                pageSize: params.pageSize ?? 10,
                ...(params.search ? { search: params.search } : {}),
            },
        },
    );
    return response.data;
}

export async function fetchContactById(contactId: string): Promise<LawFirmContactDetail> {
    const response = await axiosInstance.get<LawFirmContactDetail>(`/api/v1/contacts/${contactId}`);
    return response.data;
}

export async function fetchContactsByProspectVersionId(
    prospectVersionId: number,
): Promise<ContactVersion[]> {
    const response = await axiosInstance.get<ContactVersion[]>(
        `/api/v1/contacts/${prospectVersionId}`,
    );
    return response.data;
}

export interface AddIntakeContactPayload {
    prospectId: string;
    firstName: string;
    middleName?: string;
    lastName: string;
    contactEmail: string;
    phoneNumber?: string;
}

export async function addIntakeContact(payload: AddIntakeContactPayload): Promise<ContactVersion> {
    const response = await axiosInstance.post<ContactVersion>('/api/v1/contacts', payload);
    return response.data;
}

export interface RemoveIntakeContactPayload {
    prospectId: string;
    contactId: string;
}

export interface RemoveIntakeContactResponse {
    remainingContacts: ContactVersion[];
    primaryContact: ContactVersion;
}

export async function removeIntakeContact(
    payload: RemoveIntakeContactPayload,
): Promise<RemoveIntakeContactResponse> {
    const response = await axiosInstance.delete<RemoveIntakeContactResponse>(
        `/api/v1/contacts/${payload.contactId}`,
        { data: { prospectId: payload.prospectId } },
    );
    return response.data;
}
